export var ESBAmericanType = {
  OptionValue: 0,
  Delta: 1,
  Elasticity: 2,
  Gamma: 3,
  DGammaDVol: 4,
  GammaP: 5,
  TimeGamma: 6,
  DDeletaDVol: 7,
  Vega: 8,
  DVegaDVol_Vomma: 9,
  VegaP: 10,
  DVegaDVol: 11,
  Theta: 12,
  RHO: 13,
  FuturesOptionRHO: 14,
  RHO2: 15,
  Carry: 16,
  Speed: 17,
  StrikeDelta: 18,
  StrikeGamma: 19,
  DifferenceVal: 20
}
Object.freeze(ESBAmericanType)

export function OptionPricingFormula() {
  OptionPricingFormula.prototype.cnd = function (x) {
    var y = Math.abs(x)
    var result = 0
    if (y > 37) {
      return 0
    } else {
      var exp = Math.exp(-Math.pow(y, 2) / 2)
      if (y < 7.07106781186547) {
        var sumA = 0.0352624965998911 * y + 0.700383064443688
        sumA = sumA * y + 6.37396220353165
        sumA = sumA * y + 33.912866078383
        sumA = sumA * y + 112.079291497871
        sumA = sumA * y + 221.213596169931
        sumA = sumA * y + 220.206867912376
        var sumB = 0.0883883476483184 * y + 1.75566716318264
        sumB = sumB * y + 16.064177579207
        sumB = sumB * y + 86.7807322029461
        sumB = sumB * y + 296.564248779674
        sumB = sumB * y + 637.333633378831
        sumB = sumB * y + 793.826512519948
        sumB = sumB * y + 440.413735824752

        result = exp * sumA / sumB
      } else {
        sumA = y + 0.65
        sumA = y + 4 / sumA
        sumA = y + 3 / sumA
        sumA = y + 2 / sumA
        sumA = y + 1 / sumA
        result = exp / (sumA * 2.506628274631)
      }
    }

    if (x > 0) {
      result = 1 - result
    }

    return result
  }

  OptionPricingFormula.prototype.gBlackScholes = function (isCall, price, strikePrice, daysLeft, riskFree, costOfCarry, vol) {
    var d1 = (Math.log(price / strikePrice) + (costOfCarry + Math.pow(vol, 2) / 2) * daysLeft) / (vol * Math.sqrt(daysLeft))
    var d2 = d1 - vol * Math.sqrt(daysLeft)

    if (isCall) {
      return price * Math.exp((costOfCarry - riskFree) * daysLeft) * this.cnd(d1) - strikePrice * Math.exp(-riskFree * daysLeft) * this.cnd(d2)
    } else {
      return strikePrice * Math.exp(-riskFree * daysLeft) * this.cnd(-d2) - price * Math.exp((costOfCarry - riskFree) * daysLeft) * this.cnd(-d1)
    }
  }

  OptionPricingFormula.prototype.normalDistribution = function (x) {
    return 1 / Math.sqrt(2 * Math.PI) * Math.exp(-Math.pow(x, 2) / 2)
  }

  OptionPricingFormula.prototype.gVega = function (stockPrice, strikePrice, timeToMaturity, riskFree, costOfCarry, vol) {
    var d1 = (Math.log(stockPrice / strikePrice) + (costOfCarry + Math.pow(vol, 2) / 2) * timeToMaturity) / (vol * Math.sqrt(timeToMaturity))
    return stockPrice * Math.exp((costOfCarry - riskFree) * timeToMaturity) * this.normalDistribution(d1) * Math.sqrt(timeToMaturity)
  }

  OptionPricingFormula.prototype.phi = function (price, daysLeft, gamma, i1, i2, riskFree, costOfCarry, vol) {
    var lambda = (-riskFree + gamma * costOfCarry + 0.5 * gamma * (gamma - 1) * Math.pow(vol, 2)) * daysLeft
    var d = -(Math.log(price / i1) + (costOfCarry + (gamma - 0.5) * Math.pow(vol, 2)) * daysLeft) / (vol * Math.sqrt(daysLeft))
    var kappa = 2 * costOfCarry / Math.pow(vol, 2) + 2 * gamma - 1
    var returnValue = Math.exp(lambda) * Math.pow(price, gamma) * (this.cnd(d) - Math.pow((i2 / price), kappa) * this.cnd(d - 2 * Math.log(i2 / price) / (vol * Math.sqrt(daysLeft))))

    return returnValue
  }

  OptionPricingFormula.prototype.cbnd = function (x, y, rho) {
    var i = 0
    var ISs = 0
    var LG = 0
    var NG = 0
    var h = 0
    var k = 0
    var hk = 0
    var hs = 0
    var BVN = 0
    var Ass = 0
    var asr = 0
    var sn = 0
    var A = 0
    var b = 0
    var bs = 0
    var c = 0
    var d = 0
    var xs = 0
    var rs = 0

    var w = []
    w.push([0.17132449237917, 0.0471753363865118, 0.0176140071391521])
    w.push([0.360761573048138, 0.106939325995318, 0.0406014298003869])
    w.push([0.46791393457269, 0.160078328543346, 0.0626720483341091])
    w.push([-1, 0.203167426723066, 0.0832767415767048])
    w.push([-1, 0.233492536538355, 0.10193011981724])
    w.push([-1, 0.249147045813403, 0.118194531961518])
    w.push([-1, -1, 0.131688638449177])
    w.push([-1, -1, 0.142096109318382])
    w.push([-1, -1, 0.149172986472604])
    w.push([-1, -1, 0.152753387130726])

    var xx = []
    xx.push([-0.932469514203152, -0.981560634246719, -0.993128599185095])
    xx.push([-0.661209386466265, -0.904117256370475, -0.963971927277914])
    xx.push([-0.238619186083197, -0.769902674194305, -0.912234428251326])
    xx.push([-1, -0.587317954286617, -0.839116971822219])
    xx.push([-1, -0.36783149899818, -0.746331906460151])
    xx.push([-1, -0.125233408511469, -0.636053680726515])
    xx.push([-1, -1, -0.510867001950827])
    xx.push([-1, -1, -0.37370608871542])
    xx.push([-1, -1, -0.227785851141645])
    xx.push([-1, -1, -0.0765265211334973])

    if (Math.abs(rho) < 0.3) {
      NG = 1
      LG = 3
    } else {
      if (Math.abs(rho) < 0.75) {
        NG = 2
        LG = 6
      } else {
        NG = 3
        LG = 10
      }
    }

    h = -x
    k = -y
    hk = h * k
    BVN = 0

    if (Math.abs(rho) < 0.925) {
      if (Math.abs(rho) > 0) {
        hs = (h * h + k * k) / 2
        asr = this.arcSin(rho)
        for (i = 0; i <= LG - 1; i++) {
          for (ISs = -1; ISs <= 1; ISs += 2) {
            sn = Math.sin(asr * (ISs * xx[i][NG - 1] + 1) / 2)
            BVN = BVN + w[i][NG - 1] * Math.exp((sn * hk - hs) / (1 - sn * sn))
          }
        }
        BVN = BVN * asr / (4 * Math.PI)
      }
      BVN = BVN + this.cnd(-h) * this.cnd(-k)
    } else {
      if (rho < 0) {
        k = -k
        hk = -hk
      }
      if (Math.abs(rho) < 1) {
        Ass = (1 - rho) * (1 + rho)
        A = Math.sqrt(Ass)
        bs = Math.pow((h - k), 2)
        c = (4 - hk) / 8
        d = (12 - hk) / 16
        asr = -(bs / Ass + hk) / 2
        if (asr > -100) { BVN = A * Math.exp(asr) * (1 - c * (bs - Ass) * (1 - d * bs / 5) / 3 + c * d * Ass * Ass / 5) }
        if (-hk < 100) {
          b = Math.sqrt(bs)
          BVN = BVN - Math.exp(-hk / 2) * Math.sqrt(2 * Math.PI) * this.cnd(-b / A) * b * (1 - c * bs * (1 - d * bs / 5) / 3)
        }
        A = A / 2
        for (i = 0; i <= LG - 1; i++) {
          for (ISs = -1; ISs <= 1; ISs += 2) {
            xs = Math.pow((A * (ISs * xx[i][NG - 1] + 1)), 2)
            rs = Math.sqrt(1 - xs)
            asr = -(bs / xs + hk) / 2
            if (asr > -100) {
              BVN = BVN + A * w[i][NG] * Math.exp(asr) * (Math.exp(-hk * (1 - rs) / (2 * (1 + rs))) / rs - (1 + c * xs * (1 + d * xs)))
            }
          }
        }
        BVN = -BVN / (2 * Math.PI)
      }
      if (rho > 0) {
        BVN = BVN + this.cnd(-Math.max(h, k))
      } else {
        BVN = -BVN
        if (k > h) { BVN = BVN + this.cnd(k) - this.cnd(h) }
      }
    }
    return BVN
  }

  OptionPricingFormula.prototype.ksi = function (s, t2, gamma, h, i2, i1, t1, r, b, v) {
    var e1 = (Math.log(s / i1) + (b + (gamma - 0.5) * Math.pow(v, 2)) * t1) / (v * Math.sqrt(t1))
    var e2 = (Math.log(Math.pow(i2, 2) / (s * i1)) + (b + (gamma - 0.5) * Math.pow(v, 2)) * t1) / (v * Math.sqrt(t1))
    var e3 = (Math.log(s / i1) - (b + (gamma - 0.5) * Math.pow(v, 2)) * t1) / (v * Math.sqrt(t1))
    var e4 = (Math.log(Math.pow(i2, 2) / (s * i1)) - (b + (gamma - 0.5) * Math.pow(v, 2)) * t1) / (v * Math.sqrt(t1))

    var f1 = (Math.log(s / h) + (b + (gamma - 0.5) * Math.pow(v, 2)) * t2) / (v * Math.sqrt(t2))
    var f2 = (Math.log(Math.pow(i2, 2) / (s * h)) + (b + (gamma - 0.5) * Math.pow(v, 2)) * t2) / (v * Math.sqrt(t2))
    var f3 = (Math.log(Math.pow(i1, 2) / (s * h)) + (b + (gamma - 0.5) * Math.pow(v, 2)) * t2) / (v * Math.sqrt(t2))
    var f4 = (Math.log(s * Math.pow(i1, 2) / (h * Math.pow(i2, 2))) + (b + (gamma - 0.5) * Math.pow(v, 2)) * t2) / (v * Math.sqrt(t2))

    var rho = Math.sqrt(t1 / t2)
    var lambda = -r + gamma * b + 0.5 * gamma * (gamma - 1) * Math.pow(v, 2)
    var kappa = 2 * b / (Math.pow(v, 2)) + (2 * gamma - 1)

    return Math.exp(lambda * t2) * Math.pow(s, gamma) * (this.cbnd(-e1, -f1, rho) - Math.pow((i2 / s), kappa) * this.cbnd(-e2, -f2, rho) - Math.pow((i1 / s), kappa) * this.cbnd(-e3, -f3, -rho) + Math.pow((i1 / i2), kappa) * this.cbnd(-e4, -f4, -rho))
  }

  OptionPricingFormula.prototype.arcSin = function (x) {
    var returnValue = 0.0
    if (Math.abs(x) === 1) {
      var sign = 0
      if (x > 0) {
        sign = 1
      } else {
        sign = -1
      }

      returnValue = sign * Math.PI / 2
    } else {
      returnValue = Math.atan(x / Math.sqrt(1 - Math.pow(x, 2)))
    }

    return returnValue
  }

  OptionPricingFormula.prototype.bSAmericanCallApprox2002 = function (S, X, T, r, b, v) {
    var t1 = 1 / 2 * (Math.sqrt(5) - 1) * T

    if (b >= r) {
      return this.gBlackScholes(true, S, X, T, r, b, v)
    } else {
      var Beta = (1 / 2 - b / Math.pow(v, 2)) + Math.sqrt(Math.pow((b / Math.pow(v, 2) - 1 / 2), 2) + 2 * r / Math.pow(v, 2))
      var BInfinity = Beta / (Beta - 1) * X
      var B0 = Math.max(X, r / (r - b) * X)

      var ht1 = -(b * t1 + 2 * v * Math.sqrt(t1)) * Math.pow(X, 2) / ((BInfinity - B0) * B0)
      var ht2 = -(b * T + 2 * v * Math.sqrt(T)) * Math.pow(X, 2) / ((BInfinity - B0) * B0)
      var I1 = B0 + (BInfinity - B0) * (1 - Math.exp(ht1))
      var I2 = B0 + (BInfinity - B0) * (1 - Math.exp(ht2))
      var alfa1 = (I1 - X) * Math.pow(I1, (-Beta))
      var alfa2 = (I2 - X) * Math.pow(I2, (-Beta))

      if (S >= I2) {
        return S - X
      } else {
        return alfa2 * Math.pow(S, Beta) - alfa2 * this.phi(S, t1, Beta, I2, I2, r, b, v) + this.phi(S, t1, 1, I2, I2, r, b, v) - this.phi(S, t1, 1, I1, I2, r, b, v) - X * this.phi(S, t1, 0, I2, I2, r, b, v) + X * this.phi(S, t1, 0, I1, I2, r, b, v) + alfa1 * this.phi(S, t1, Beta, I1, I2, r, b, v) - alfa1 * this.ksi(S, T, Beta, I1, I2, I1, t1, r, b, v) + this.ksi(S, T, 1, I1, I2, I1, t1, r, b, v) - this.ksi(S, T, 1, X, I2, I1, t1, r, b, v) - X * this.ksi(S, T, 0, I1, I2, I1, t1, r, b, v) + X * this.ksi(S, T, 0, X, I2, I1, t1, r, b, v)
      }
    }
  }

  OptionPricingFormula.prototype.bSAmericanApprox2002 = function (isCall, S, X, T, r, b, v) {
    if (isCall) {
      return this.bSAmericanCallApprox2002(S, X, T, r, b, v)
    } else {
      return this.bSAmericanCallApprox2002(X, S, T, r - b, -b, v)
    }
  }

  OptionPricingFormula.prototype.gImpliedVolatilityNR = function (isCall, stockPrice, strikePrice, timeToMaturity, riskFree, costOfCarry, optionPrice) {

    var epsilon = 0.00001
    var vi = Math.sqrt(Math.abs(Math.log(stockPrice / strikePrice) + riskFree * timeToMaturity) * 2 / timeToMaturity)
    var ci = this.gBlackScholes(isCall, stockPrice, strikePrice, timeToMaturity, riskFree, costOfCarry, vi)
    var vegai = this.gVega(stockPrice, strikePrice, timeToMaturity, riskFree, costOfCarry, vi)
    var minDiff = Math.abs(optionPrice - ci)


    // --- FAIL SAFE ---
    let hardFail = 1000

    while (Math.abs(optionPrice - ci) >= epsilon && Math.abs(optionPrice - ci) <= minDiff) {

      vi = vi - (ci - optionPrice) / vegai
      ci = this.gBlackScholes(isCall, stockPrice, strikePrice, timeToMaturity, riskFree, costOfCarry, vi)
      vegai = this.gVega(stockPrice, strikePrice, timeToMaturity, riskFree, costOfCarry, vi)
      minDiff = Math.abs(optionPrice - ci)

      hardFail--

      if (Math.abs(optionPrice - ci) < epsilon) return vi
      else if (hardFail === 0) return 'NA' 
    }
  }

  OptionPricingFormula.prototype.gImpliedVolatilityNR1 = function (optionType, optionPrice, s, x, t, r) {
    var sgm = [0.0, 0.0, 0.0]
    var cnt = 0

    while ((this.gBlackScholes(optionType, s, x, t, r, 0, sgm[2]) - optionPrice <= 0 && cnt < 10)) {
      sgm[2] += 100
      cnt += 1
    }

    if ((cnt === 10)) { return 0 }

    sgm[1] = 0.5 * (sgm[0] + sgm[2])
    cnt = 0
    sgm = [0.0, 0.0, 0.0]
    while ((Math.abs(sgm[2] - sgm[0]) > 0.01 && cnt < 100)) {
      var y = []
      y[0] = this.gBlackScholes(optionType, s, x, t, r, 0, sgm[0]) - optionPrice
      y[1] = this.gBlackScholes(optionType, s, x, t, r, 0, sgm[1]) - optionPrice
      y[2] = this.gBlackScholes(optionType, s, x, t, r, 0, sgm[2]) - optionPrice

      if ((y[0] * y[1] < 0)) {
        sgm[2] = sgm[1]
      } else if ((y[1] * y[2] < 0)) {
        sgm[0] = sgm[1]
      } else {
      }
      sgm[1] = 0.5 * (sgm[0] + sgm[2])

      cnt += 1
    }

    return sgm[1]
  }

  OptionPricingFormula.prototype.calculateClosedOptionPosition = function (instrument, tradeSide, strike, stockPrice, qty, openPrice, multiplier) {
    if (((instrument === 2) ||
      (instrument === 5))) {
      return 0
    }

    // *** UNUSED VARIABLE ***
    // var intCreditDebit = 1
    // if ((tradeSide === 1)) {
    // 	intCreditDebit = -1
    // }

    if ((instrument === 0)) {
      if ((strike >= stockPrice)) {
        return +(openPrice * qty * -1 * multiplier).toFixed(4)
      } else {
        return +(((stockPrice - strike) * qty * multiplier) - (openPrice * qty * multiplier)).toFixed(4)
      }
    }

    if ((tradeSide === 0)) {

    }

    if ((instrument === 1)) {
      if ((strike >= stockPrice)) {
        return +(((strike - stockPrice) * qty * multiplier) - (openPrice * qty * multiplier)).toFixed(4)
      } else {
        return +(openPrice * qty * multiplier * -1).toFixed(4)
      }
    }
  }

  OptionPricingFormula.prototype.eBSAmericanApprox2002 = function (ebsAmericanType, callPut, assetPrice, strikePrice, daysLeft, riskFree, costOfCarry, vol, dS) {
    if (dS === null || dS === 0) {
      dS = 0.01
    }

    if (ebsAmericanType === ESBAmericanType.OptionValue) {
      return this.bSAmericanApprox2002(callPut, assetPrice, strikePrice, daysLeft, riskFree, costOfCarry, vol)
    }

    if (ebsAmericanType === ESBAmericanType.Delta) {
      return (this.bSAmericanApprox2002(callPut, assetPrice + dS, strikePrice, daysLeft, riskFree, costOfCarry, vol) - this.bSAmericanApprox2002(callPut, assetPrice - dS, strikePrice, daysLeft, riskFree, costOfCarry, vol)) / (2 * dS)
    }

    if (ebsAmericanType === ESBAmericanType.Elasticity) {
      return (this.bSAmericanApprox2002(callPut, assetPrice + dS, strikePrice, daysLeft, riskFree, costOfCarry, vol) - this.bSAmericanApprox2002(callPut, assetPrice - dS, strikePrice, daysLeft, riskFree, costOfCarry, vol)) / (2 * dS) * assetPrice / this.bSAmericanApprox2002(callPut, assetPrice, strikePrice, daysLeft, riskFree, costOfCarry, vol)
    }

    if (ebsAmericanType === ESBAmericanType.Gamma) {
      return (this.bSAmericanApprox2002(callPut, assetPrice + dS, strikePrice, daysLeft, riskFree, costOfCarry, vol) - 2 * this.bSAmericanApprox2002(callPut, assetPrice, strikePrice, daysLeft, riskFree, costOfCarry, vol) + this.bSAmericanApprox2002(callPut, assetPrice - dS, strikePrice, daysLeft, riskFree, costOfCarry, vol)) / Math.pow(dS, 2)
    }

    if (ebsAmericanType === ESBAmericanType.DGammaDVol) {
      return (this.bSAmericanApprox2002(callPut, assetPrice + dS, strikePrice, daysLeft, riskFree, costOfCarry, vol + 0.01) - 2 * this.bSAmericanApprox2002(callPut, assetPrice, strikePrice, daysLeft, riskFree, costOfCarry, vol + 0.01) + this.bSAmericanApprox2002(callPut, assetPrice - dS, strikePrice, daysLeft, riskFree, costOfCarry, vol + 0.01) - this.bSAmericanApprox2002(callPut, assetPrice + dS, strikePrice, daysLeft, riskFree, costOfCarry, vol - 0.01) + 2 * this.bSAmericanApprox2002(callPut, assetPrice, strikePrice, daysLeft, riskFree, costOfCarry, vol - 0.01) - this.bSAmericanApprox2002(callPut, assetPrice - dS, strikePrice, daysLeft, riskFree, costOfCarry, vol - 0.01)) / (2 * 0.01 * Math.pow(dS, 2)) / 100
    }

    if (ebsAmericanType === ESBAmericanType.GammaP) {
      return assetPrice / 100 * (this.bSAmericanApprox2002(callPut, assetPrice + dS, strikePrice, daysLeft, riskFree, costOfCarry, vol) - 2 * this.bSAmericanApprox2002(callPut, assetPrice, strikePrice, daysLeft, riskFree, costOfCarry, vol) + this.bSAmericanApprox2002(callPut, assetPrice - dS, strikePrice, daysLeft, riskFree, costOfCarry, vol)) / Math.pow(dS, 2)
    }

    if (ebsAmericanType === ESBAmericanType.TimeGamma) {
      return (this.bSAmericanApprox2002(callPut, assetPrice, strikePrice, daysLeft + 1 / 365, riskFree, costOfCarry, vol) - 2 * this.bSAmericanApprox2002(callPut, assetPrice, strikePrice, daysLeft, riskFree, costOfCarry, vol) + this.bSAmericanApprox2002(callPut, assetPrice, strikePrice, daysLeft - 1 / 365, riskFree, costOfCarry, vol)) / Math.pow((1 / 365), 2)
    }

    if (ebsAmericanType === ESBAmericanType.DDeletaDVol) {
      return 1 / (4 * dS * 0.01) * (this.bSAmericanApprox2002(callPut, assetPrice + dS, strikePrice, daysLeft, riskFree, costOfCarry, vol + 0.01) - this.bSAmericanApprox2002(callPut, assetPrice + dS, strikePrice, daysLeft, riskFree, costOfCarry, vol - 0.01) - this.bSAmericanApprox2002(callPut, assetPrice - dS, strikePrice, daysLeft, riskFree, costOfCarry, vol + 0.01) + this.bSAmericanApprox2002(callPut, assetPrice - dS, strikePrice, daysLeft, riskFree, costOfCarry, vol - 0.01)) / 100
    }

    if (ebsAmericanType === ESBAmericanType.Vega) {
      return (this.bSAmericanApprox2002(callPut, assetPrice, strikePrice, daysLeft, riskFree, costOfCarry, vol + 0.01) - this.bSAmericanApprox2002(callPut, assetPrice, strikePrice, daysLeft, riskFree, costOfCarry, vol - 0.01)) / 2
    }

    if (ebsAmericanType === ESBAmericanType.DVegaDVol_Vomma) {
      return (this.bSAmericanApprox2002(callPut, assetPrice, strikePrice, daysLeft, riskFree, costOfCarry, vol + 0.01) - 2 * this.bSAmericanApprox2002(callPut, assetPrice, strikePrice, daysLeft, riskFree, costOfCarry, vol) + this.bSAmericanApprox2002(callPut, assetPrice, strikePrice, daysLeft, riskFree, costOfCarry, vol - 0.01)) / Math.pow(0.01, 2) / 10000
    }

    if (ebsAmericanType === ESBAmericanType.VegaP) {
      return vol / 0.1 * (this.bSAmericanApprox2002(callPut, assetPrice, strikePrice, daysLeft, riskFree, costOfCarry, vol + 0.01) - this.bSAmericanApprox2002(callPut, assetPrice, strikePrice, daysLeft, riskFree, costOfCarry, vol - 0.01)) / 2
    }

    if (ebsAmericanType === ESBAmericanType.DVegaDVol) {
      return (this.bSAmericanApprox2002(callPut, assetPrice, strikePrice, daysLeft, riskFree, costOfCarry, vol + 0.01) - 2 * this.bSAmericanApprox2002(callPut, assetPrice, strikePrice, daysLeft, riskFree, costOfCarry, vol) + this.bSAmericanApprox2002(callPut, assetPrice, strikePrice, daysLeft, riskFree, costOfCarry, vol - 0.01))
    }

    if (ebsAmericanType === ESBAmericanType.Theta) {
      // Theta
      if (daysLeft <= 1 / 365) {
        return this.bSAmericanApprox2002(callPut, assetPrice, strikePrice, 1E-05, riskFree, costOfCarry, vol) - this.bSAmericanApprox2002(callPut, assetPrice, strikePrice, daysLeft, riskFree, costOfCarry, vol)
      } else {
        return this.bSAmericanApprox2002(callPut, assetPrice, strikePrice, daysLeft - 1 / 365, riskFree, costOfCarry, vol) - this.bSAmericanApprox2002(callPut, assetPrice, strikePrice, daysLeft, riskFree, costOfCarry, vol)
      }
    }

    if (ebsAmericanType === ESBAmericanType.RHO) {
      return (this.bSAmericanApprox2002(callPut, assetPrice, strikePrice, daysLeft, riskFree + 0.01, costOfCarry + 0.01, vol) - this.bSAmericanApprox2002(callPut, assetPrice, strikePrice, daysLeft, riskFree - 0.01, costOfCarry - 0.01, vol)) / (2)
    }

    if (ebsAmericanType === ESBAmericanType.FuturesOptionRHO) {
      return (this.bSAmericanApprox2002(callPut, assetPrice, strikePrice, daysLeft, riskFree + 0.01, costOfCarry, vol) - this.bSAmericanApprox2002(callPut, assetPrice, strikePrice, daysLeft, riskFree - 0.01, costOfCarry, vol)) / (2)
    }

    if (ebsAmericanType === ESBAmericanType.RHO2) {
      return (this.bSAmericanApprox2002(callPut, assetPrice, strikePrice, daysLeft, riskFree, costOfCarry - 0.01, vol) - this.bSAmericanApprox2002(callPut, assetPrice, strikePrice, daysLeft, riskFree, costOfCarry + 0.01, vol)) / (2)
    }

    if (ebsAmericanType === ESBAmericanType.Carry) {
      return (this.bSAmericanApprox2002(callPut, assetPrice, strikePrice, daysLeft, riskFree, costOfCarry + 0.01, vol) - this.bSAmericanApprox2002(callPut, assetPrice, strikePrice, daysLeft, riskFree, costOfCarry - 0.01, vol)) / (2)
    }

    if (ebsAmericanType === ESBAmericanType.Speed) {
      return 1 / Math.pow(dS, 3) * (this.bSAmericanApprox2002(callPut, assetPrice + 2 * dS, strikePrice, daysLeft, riskFree, costOfCarry, vol) - 3 * this.bSAmericanApprox2002(callPut, assetPrice + dS, strikePrice, daysLeft, riskFree, costOfCarry, vol) + 3 * this.bSAmericanApprox2002(callPut, assetPrice, strikePrice, daysLeft, riskFree, costOfCarry, vol) - this.bSAmericanApprox2002(callPut, assetPrice - dS, strikePrice, daysLeft, riskFree, costOfCarry, vol))
    }

    if (ebsAmericanType === ESBAmericanType.StrikeDelta) {
      return (this.bSAmericanApprox2002(callPut, assetPrice, strikePrice + dS, daysLeft, riskFree, costOfCarry, vol) - this.bSAmericanApprox2002(callPut, assetPrice, strikePrice - dS, daysLeft, riskFree, costOfCarry, vol)) / (2 * dS)
    }

    if (ebsAmericanType === ESBAmericanType.StrikeGamma) {
      return (this.bSAmericanApprox2002(callPut, assetPrice, strikePrice + dS, daysLeft, riskFree, costOfCarry, vol) - 2 * this.bSAmericanApprox2002(callPut, assetPrice, strikePrice, daysLeft, riskFree, costOfCarry, vol) + this.bSAmericanApprox2002(callPut, assetPrice, strikePrice - dS, daysLeft, riskFree, costOfCarry, vol)) / Math.pow(dS, 2)
    }

    if (ebsAmericanType === ESBAmericanType.DifferenceVal) {
      return this.bSAmericanApprox2002(callPut, assetPrice, strikePrice, daysLeft, riskFree, costOfCarry, vol) - this.gBlackScholes(callPut, assetPrice, strikePrice, daysLeft, riskFree, costOfCarry, vol)
    }
  }
};



// WEBPACK FOOTER //
// ./src/services/greeks/index.js